define('modules/editor/views/property_boxes/base',['require','exports','module','spectrum','base/itemview','underscore','lib/util'],function(require, exports, module) {
  "use strict";
  require("spectrum");
  var ItemView = require("base/itemview"),
      _ = require("underscore"),
      util = require("lib/util");

  module.exports = ItemView.extend({
    /** hash with translation keys, will be filled with values
        So later on we can use this.i18n.keyName to get the translation
    **/
    i18n: {
      //keyName: "editor.translations.key"
    },
    events: {
      // keypress identifies the character, keydown identifies the physical key stroked
      "keypress": "_filterValues",
      "keyup": _.debounce(util.bbinvoker("_getPropertyValues"), 300),
      "change .colorpicker": _.debounce(util.bbinvoker("_getPropertyValues"),200),
      "change select": "_getPropertyValues",
      "change input[type=checkbox]": "_getPropertyValues",
      "change textarea": "_getPropertyValues",
      "submit form": "preventDefault"
    },
    initialize: function(options) {
      this.data = this.parent.data;
      this.tooltips = [];
      this._loadViewTranslations();
    },
    preventDefault: function(e){
      e.preventDefault();
    },
    _loadViewTranslations: function(){
      _.each(_.keys(this.i18n), function(key){
        this.i18n[key] = $.i18n.t(this.i18n[key]);
      }, this);
    },
    _unbindModelEvents: function() {
      this.stopListening(this.model);
    },
    _bindModelEvents: function() {
      this.listenTo(this.model, "change invalid", this.render);
    },
    _propertyElementsFold: function(fn) {
      return _.foldl(this.model.properties, function(acc, name) {
        var $el = this.$("[data-property=" + name + "]"),
            elType = $el.attr("type"),
            value = $el.val();
        //checkboxes
        if(elType === "checkbox"){
          value = $el.is(":checked");
        }
        //console.log(name, value);
        return fn.call(this, acc, name, $el, value);
      }, {}, this);
    },
    _getPropertyValues: function(e) {
      // unbind so this call to model.set(...) doesn't re-render the box
      this._unbindModelEvents();
      this.listenTo(this.model, "invalid:property", function(prop){
        this._addPropertyError(prop);
      });
      //gather all properties
      var propAttrs = this._propertyElementsFold(function(acc, name, $el, value) {
        acc[name] = value;
        return acc;
      });


      this.model.set(propAttrs, { validate: true });
      if(!this.model.validationError){
        this._cleanUpErrors();
        this.model.trigger("change");
      }
      //uncomment to debug property parsing
      //console.log(this.model.toJSON());
      // bind it f again
      this._bindModelEvents();
    },
    _setPropertyValues: function() {
      this._propertyElementsFold(function(acc, name, $el, value) {
        if($el.attr("type") === "checkbox"){
          $el.attr("checked", Boolean(this.model.get(name)));
        } else if ($el.attr("type") === "radio") {
          var inputValue = this.model.get(name);
          $el.filter('[value="' + inputValue + '"]').attr('checked', true);
        }
        else {
          $el.val(this.model.get(name));
        }
      });
    },
    _cleanUpErrors: function(){
      this.$(".ed-form-group").removeClass("has-error");
      _.invoke(this.tooltips, "remove");
    },
    _addPropertyError: function(propName){
      var propField = this.$("[data-property='" + propName + "']"),
          valMessage = propField.data("validation-message"),
          valMinValue = propField.data("validation-min"),
          valMaxValue = propField.data("validation-max");
      //add error
      this.$("[data-property='" + propName + "']").parent().addClass("has-error");
      if(!valMessage) {
        return;
      }
      //get i18n message
      var message = $.i18n.t("editor.validationMessages." + valMessage);
      if(message.indexOf("{0}") > -1){
        //replace min value {0}
        message = message.replace("{0}", valMinValue);
        if(message.indexOf("{1}") > -1){
          //replace max value {1}
          message = message.replace("{1}", valMaxValue || "");
        }
      }
      //show tooltip
      this._showTooltip(propField, message);
    },
    _showTooltip: function($field, message){
      var $tooltip = $("<div />")
        .addClass("tooltip bottom in");
      var $tooltipInner = $("<div />")
        .addClass("tooltip-inner")
        .html(message).appendTo($tooltip);

      $tooltip.appendTo($field.parent());
      this.tooltips.push($tooltip);
    },
    render: function() {
      this.triggerMethod("before:render");
      module.exports.__super__.render.call(this);
      this._setPropertyValues();
      this._destroyColorPickers();
      this.$el.find("input.colorpicker").spectrum({
        showInput:true
      });
      //add alpha
      this.$el.find("input.colorpicker.alpha").spectrum({
        showAlpha:true,
        showInput:true
      });
      //i18n
      this.$el.i18n();
      // visibility
      if (this.viewModel) {
        this.$el.toggle(!!this.viewModel.get("visible"));
      }
      return this;
    },
    onRemove: function(){
      //destroy before creating to stop spawning infinite colorpickers
      this._destroyColorPickers();
      this._cleanUpErrors();
    },
    _destroyColorPickers: function(){
      this.$el.find("input.colorpicker").spectrum("destroy");
      // $(".sp-container").remove();
      //NOTE: bug in spectrum doesn't remove its replace elements
    },
    _filterValues: function(e){
      //override in child classes if needed

    }
  });

});

